<template>
    <div class="bg-color">
        <Navbar />
        <Header :category="'aboutus'" :bannerTitle="bannerTitle" :breadCrumb="breadCrumb" :basicNavTitle="aboutNavTitle"/>
        <ContactUsBody />
        <FooterTop />
        <FooterBottom />
    </div>
</template>

<script>

    import Navbar from 'components/DefaultHome/KECC/Common/NavbarStyle'
    import Header from 'components/DefaultHome/KECC/Common/Header'
    import ContactUsBody from './ContactUsBody'
    import FooterTop from 'components/DefaultHome/KECC/Common/FooterTop?v=1.0'
    import FooterBottom from 'components/DefaultHome/KECC/Common/BacktopButton'

    export default {
        name: 'ContactUsMain',
        metaInfo() {
            return {
                title: this.$t("navbar.menu_4_4"),
            }
        },
        components: {
            Navbar,
            Header,
            ContactUsBody,
            FooterTop,
            FooterBottom,
        },
        data() {
            return {
                bannerTitle: "JOIN US",
                breadCrumb: [{
                    name: this.$t('navbar.menu_4')
                }],
                aboutNavTitle: [
                    '專業團隊',
                    '加入我們',
                    '聯絡我們',
                ]
            }
        },
    }
</script>

<style scoped>
    .bg-color {
        background-color: #eff4f5;
    }
</style>